import React from 'react';
import { componentService } from '@core/js/services/component.service';

export const TopWinners = React.lazy(() => import(/* webpackChunkName: "top-winners" */ './TopWinners'));

componentService.registerPageComponents({ 'top-winners': TopWinners });
/*
<hub2-top-winners config="{
    'mobile': {
        'period': '1',
        'topLength': 10,
        'view': 'carousel',
        'winnersInfo': 'initials'
    },
    'tablet': {
        'period': '7',
        'topLength': 20,
        'view': 'table',
         'rowsAmount': 5,
         'winnersInfo': 'nickname'
    },
    'desktop': {
        'period': '30',
        'topLength': 30,
        'view': 'line',
        'winnersInfo': 'initials'
    }
}"></hub2-top-winners>
*/
componentService.registerWebContentComponents({ TopWinners });
